<script lang="ts">
    import ActionBarButton from "../ActionBarButton.svelte";
    import { modalIframeStore, modalVisibilityStore } from "../../../Stores/ModalStore";
    import { analyticsClient } from "../../../Administration/AnalyticsClient";
    import { IconApps } from "../../Icons";

    export let first: boolean | undefined = undefined;
    export let last: boolean | undefined = undefined;
    export let classList: string | undefined = undefined;

    let dashboardOpened = false;

    function toggleDashboard() {
        if (dashboardOpened) {
            // Close the dashboard
            modalVisibilityStore.set(false);
            modalIframeStore.set(null);
        } else {
            // Open the dashboard
            modalIframeStore.set({
                src: "https://webapp.virtual.smartscholars.it",
                allow: "fullscreen",
                allowApi: true,
                position: "center",
                title: "SmartScholars Dashboard"
            });
            modalVisibilityStore.set(true);
        }
        dashboardOpened = !dashboardOpened;
        analyticsClient.openedMenu();
    }
</script>

<ActionBarButton
    label="Dashboard"
    boldLabel={true}
    hideIconInActionBar={false}
    on:click={toggleDashboard}
    bgColor="rgba(255, 255, 255, 0.1)"
    {first}
    {last}
    {classList}
>
    <IconApps class="w-5 h-5" />
</ActionBarButton>
